import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
import { PRAXIO_URL } from '../../config/praxioUrl.js'

/**
 * Where a limit stops being advice.
 *
 * The disclaimer lives on the portal, beside the terms and the privacy policy,
 * because it is the same kind of document and belongs at a url a pharmacist can
 * send to their director of professional services.
 *
 * Locale-prefixed by hand: the portal publishes French at /fr, and this SPA has
 * no localePath of its own. A French user sent to the English page would get a
 * liability text they cannot rely on in Quebec.
 *
 * Shared by the first-run dialog and the settings card, which name the same
 * document from the same corner of the same header.
 */
export function useDisclaimerUrl() {
  const { locale } = useI18n()

  return computed(() => {
    const prefix = locale.value?.startsWith('fr') ? '/fr' : ''
    return `${PRAXIO_URL}${prefix}/disclaimer`
  })
}
